
/*
--------------------------------------------------------------------------------------------------------------
Autor:              EMANUEL GUIVAR
Fecha de creacion:  09/04/2025
Sistema:            Wen seguros
Descripcion:        Funciones auxiliares
BITACORA DE CAMBIOS 
--------------------------------------------------------------------------------------------------------------
CODIGO      REQ     ANALISTA                    FECHA       MOTIVO
--------------------------------------------------------------------------------------------------------------
*/

// generar url base
let urlBase = (document.getElementsByTagName('base')[0].getAttribute('href') || '/').trim();
if (urlBase.substring(urlBase.length - 1) === '/') urlBase = urlBase.substring(0, urlBase.length - 1);

// Detectar entorno (dev/prod)
const isDevelopment = process.env.NODE_ENV === 'development';

// API desde entorno, con fallback por entorno
const apiUrl = process.env.REACT_APP_API_URL || (isDevelopment ? 'http://localhost:5000/api' : `${urlBase}`);

const Helpers = {

    /**
     * Url inicial del proyecto
     */
    UrlBase: urlBase,

    /**
    * URL del backend/API
    */
    ApiUrl: apiUrl,

    /**
     * Convierte las props del objeto ingresado, a tipo string 
     * y con valores iguales a los nombres de las propiedades
     * @param obj Objeto para obtener nombres de atributos
     */
    asignarNombres: <T extends object>(obj: T) => {
        let newobj: T = { ...obj };
        Object.keys(obj).forEach(key => {
            newobj = { ...newobj, [key]: key };
        });
        return newobj;
    },
    /**
     * Convierte las props del objeto ingresado a string, 
     * y asigna los errores ingresados a sus props correspondientes
     * @param obj Objeto para asignar errores
     */
    asignarErrores: <T extends object>(obj: T, messages: Array<ValidaInput> = []) => {
        let newobj: T = { ...obj };
        Object.keys(obj).forEach(key => {
            newobj = { ...newobj, [key]: '' };
        });
        messages.forEach(val => {
            newobj = { ...newobj, [val.input]: val.detalle };
        });
        return newobj;
    },

    /**
     * Funciones para controlar modal del componente ResultModal
     */
    toOrationCase: (oration: string): string => {
        oration = (oration || '').trim();
        return oration.split(' ').map(word => {
            word.toUpperCase();
            if (word.length > 1) word = word.substr(0, 1) + word.substr(1, word.length).toLowerCase();
            return word;
        }).join(' ');
    },

    /**
     * Coloca el favicon de efectiva
     */
    setFaviconEfectiva: (): void => {
        const fav = document.getElementById("favicon") as HTMLLinkElement;
        fav.href = `${urlBase}/faviconEfectiva.ico`;
    },
    
};
export default Helpers;